import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Col, Row } from "reactstrap";
import { H4, P } from "../../AbstractElements";
import ReferralCardBody from "./ReferralCardBody";
import { ServerPath } from "../../Constant";
import ChannelPerformance from './ChannelPerformance';
import TopPerformance from './TopPerformance';
import PerformingVolunteersTable from './PerformingVolunteersTable';
import { _axios } from '../../utils/axios';


/* -------------------- NO OF REFERRERS CARD -------------------- */
export const NumberOfReferrers = ({ count }) => {
    return (
        <Col md="4" lg="3" className="box-col-4">
            <Card className="sell-card">
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>
                                No. of Referrers
                                <i className="fa fa-circle"></i>
                            </P>
                            <H4>{count}</H4>
                        </div>
                    </div>
                </CardHeader>
                <ReferralCardBody iconType="users" />
            </Card>
        </Col>
    );
};


/* -------------------- MAIN ANALYTICS COMPONENT -------------------- */
const ReferralAnalytics = () => {

    const [referralDownloads, setReferralDownloads] = useState("--");
    const [noOfReferrers, setNoOfReferrers] = useState("--");
    const [referralRate, setReferralRate] = useState("--");

    useEffect(() => {
        const fetchReferralStats = async () => {
            try {
                const analyticsResponse = await _axios.get(`${ServerPath}/referrals/analytics`);
                console.log('referral analytics response', analyticsResponse.data);

                if (analyticsResponse.data.success) {
                    const data = analyticsResponse.data.data;

                    setReferralDownloads(
                        data.referralDownloads?.toLocaleString?.() || "0"
                    );

                    setNoOfReferrers(
                        data.noOfReferrers?.toLocaleString?.() || "0"
                    );

                    setReferralRate(
                        data.referralRate?.toLocaleString?.() || "0"
                    );
                }

            } catch (error) {
                console.error("Error fetching referral stats:", error);
            }
        };

        fetchReferralStats();
    }, []);


    return (
        <Row>

            {/* Referral Downloads Card */}
            <Col md="4" lg="3" className="box-col-4">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-success" }}>
                                    Referral Downloads
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{referralDownloads}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="share" />
                </Card>
            </Col>

            {/* No of Referrers Card */}
            <NumberOfReferrers count={noOfReferrers} />

            {/* Avg Downloads per Referrer */}
            <Col md="4" lg="3" className="box-col-4">
                <Card className="visitor-card">
                    <CardHeader>
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1">
                                <P attrPara={{ className: "square-after f-w-600 header-text-info" }}>
                                    Avg Downloads / Referrer
                                    <i className="fa fa-circle"></i>
                                </P>
                                <H4>{referralRate}</H4>
                            </div>
                        </div>
                    </CardHeader>
                    <ReferralCardBody iconType="percentage" />
                </Card>
            </Col>


            {/* CHARTS */}
            <Row>
                <Col lg="6">
                    <ChannelPerformance />
                </Col>
                <Col lg="6">
                    <TopPerformance />
                </Col>
            </Row>

            {/* TABLE */}
            <PerformingVolunteersTable />

        </Row>
    );
};

export default ReferralAnalytics;
